import React from 'react';
import { _t, formatNumber, percent } from 'utils';
import Progress from 'screens/shared/progress-bar';
import shared from 'screens/shared';
import { getValueWithDecimalChar } from 'utils/metrics';
import {
  Table, TableBody, TableCell, TableRow, Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const _n = (no) => formatNumber(no);
const _b = (num) => num / 1024 / 1024 / 1024;

export const ChartPercentage = ({
  bytes, data, icon, percentage,
}) => {
  const generateRow = ([_title = '', valueProp = 0, totalProp = 0, isByte = false], index) => {
    const isEmpty = !valueProp && !totalProp;
    const [value, total] = isByte ? [_b(valueProp), _b(totalProp)] : [valueProp, totalProp];
    const avg = isEmpty ? 0 : percent(value, total);

    const usedValue = getValueWithDecimalChar(_n(value));
    const totalValue = getValueWithDecimalChar(_n(total));

    let title = `${usedValue}${isByte ? ' GB' : ''} / ${totalValue}${isByte ? ' GB' : ''} ${isEmpty ? '' : `( ${Math.floor(avg)}% )`}`;
    if (percentage) {
      title = `${Math.round(avg)}%`;
    }
    return [
      _title,
      <Progress
        className={index ? 'summaryWidth' : ''}
        color="metricColor"
        value={avg}
        title={title}
      />,
    ];
  };

  const keyMapper = (_label, _icon) => (
    <span>
      <shared.widgets.Icon name={_icon} style={{ color: '#5e5e5e' }} />
      <span style={{ fontSize: 15 }}>{` ${_t(_label)}`}</span>
    </span>
  );

  let percentageDetails = data.map((item) => ([keyMapper(item.label, icon), item.data.used, item.data.total, bytes]));

  percentageDetails = percentageDetails.map(generateRow);

  const generateDetailTable = ([prop, value, value2], i) => (
    <Table key={`table_${i}`}>
      <TableBody>
        <TableRow key={`row_${i}`}>
          <TableCell colSpan={value === undefined ? 2 : 1} style={{ fontWeight: '500', width: 100 }}>{prop}</TableCell>
          {
            value !== undefined && value !== null
            && Object.prototype.hasOwnProperty.call(value, 'value')
              ? (
                <TableCell>
                  {`${value.prefix || ''}${value.value === undefined || Number.isNaN(value.value) ? '' : value.value}${value.suffix || ''}`}
                </TableCell>
              )
              : (
                <TableCell>{value}</TableCell>
              )
          }
          {value2 && <TableCell>{value2}</TableCell>}
        </TableRow>
      </TableBody>
    </Table>
  );

  const [master = [], ...rest] = percentageDetails;
  const masterTable = generateDetailTable(master, 0);

  return (
    <Accordion className="io-accordion">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        {masterTable}
      </AccordionSummary>
      <AccordionDetails>
        {
          rest.map((item, i) => generateDetailTable(item, i + 1))
        }
      </AccordionDetails>
    </Accordion>
  );
};
